import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  min-width: 200px;
`
